import { toast } from "sonner";

export const MINT = "Hz5ziVvDTv4r5VimiHVW3ZGkuiC9DzuLJCmrUiHP8Yoj";
export const REWARD_MINT = "A13oRB9FFaiUjfi6LdCg6p9ka1u8SfGkUFs4SKvPpump";
const SOL_MINT = "So11111111111111111111111111111111111111112";
export const STONKFUN_URL = `https://www.stonkfun.xyz/token/${MINT}`;
export const JUPITER_URL = `https://jup.ag/?sell=${SOL_MINT}&buy=${REWARD_MINT}`;
export const TELEGRAM_URL = "https://t.me/FronkVerify";
export const X_URL = "https://x.com/Fronk_sol";

export const shortMint = `${MINT.slice(0, 6)}...${MINT.slice(-6)}`;
export const shortRewardMint = `${REWARD_MINT.slice(0, 6)}...${REWARD_MINT.slice(-6)}`;

export const copyMint = async () => {
  try {
    await navigator.clipboard.writeText(MINT);
    toast.success("Mint address copied", {
      description: "Filed, stamped, and on your clipboard.",
    });
  } catch (e) {
    try {
      const ta = document.createElement("textarea");
      ta.value = MINT;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      toast.success("Mint address copied", {
        description: "Filed, stamped, and on your clipboard.",
      });
    } catch (err) {
      toast.error("Copy failed", {
        description: "Long press the address and copy it by hand.",
      });
    }
  }
};
